/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * What evidence is required for score submission
 * @export
 */
export const EvidenceRequirement = {
    NONE: 'NONE',
    SCREENSHOT: 'SCREENSHOT',
    VIDEO: 'VIDEO',
    GAME_STATS: 'GAME_STATS'
} as const;
export type EvidenceRequirement = typeof EvidenceRequirement[keyof typeof EvidenceRequirement];


export function instanceOfEvidenceRequirement(value: any): boolean {
    for (const key in EvidenceRequirement) {
        if (Object.prototype.hasOwnProperty.call(EvidenceRequirement, key)) {
            if (EvidenceRequirement[key as keyof typeof EvidenceRequirement] === value) {
                return true;
            }
        }
    }
    return false;
}

export function EvidenceRequirementFromJSON(json: any): EvidenceRequirement {
    return EvidenceRequirementFromJSONTyped(json, false);
}

export function EvidenceRequirementFromJSONTyped(json: any, ignoreDiscriminator: boolean): EvidenceRequirement {
    return json as EvidenceRequirement;
}

export function EvidenceRequirementToJSON(value?: EvidenceRequirement | null): any {
    return value as any;
}

export function EvidenceRequirementToJSONTyped(value: any, ignoreDiscriminator: boolean): EvidenceRequirement {
    return value as EvidenceRequirement;
}

